<template>
	<div>
		<el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pagination.page"
        :page-sizes="pagination.sizes"
        :page-size="pagination.size"
        :layout="pagination.layout"
        :total="pagination.total"
        style="float: right; margin: 10px 0px;">
        </el-pagination>
	</div>
</template>

<script>
export default {
	inheritAttrs: false,
	name: "SimplePagination",
    inject: ['pagination', 'getList'],
	props: {
		
	},
	data() {
		return {
			
		};
	},
    methods: {
        handleSizeChange(val) {
			this.pagination.size = val;
            this.$emit("search");
		},
		handleCurrentChange(val) {
			this.pagination.page = val;
            this.$emit("search");
		},
    }
};
</script>
